module.exports = __webpack_public_path__ + "assets/img/20231121.21606bde.png";